<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>Remessa TCEPE - Modelo de Planilha de Itens do IJ</span>
                </h4>
                <b-row v-if="exibirSelect">
                    <b-col sm="12" md="10">
                        <b-form-group>
                            <model-list-select
                                :list="fornecedores"
                                option-text="nome"
                                option-value="cnpj"
                                @input="onChangeFornecedor"
                                v-model="fornecedor">
                            </model-list-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="2">
                        <b-button variant="primary" @click="limparFiltro()">Limpar</b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <b-alert variant="secondary" :show="exibirDadoFornecedor">
                            <div class="d-flex justify-content-between">
                                <div><b>{{ nomeFornecedor }}</b></div>
                                <div><b>{{ cnpjFornecedor }}</b></div>
                            </div>
                        </b-alert>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <app-tabela
                            :bordered="true"
                            :small="false"
                            :mostrarFiltro="false"
                            :itens="relatorios"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina">
                            <template slot="valorUnitario" slot-scope="data">
                                <span class="text-nowrap">{{
                                data.valorUnitario | currency
                                }}</span>
                            </template>
                            <template slot="valorTotal" slot-scope="data">
                                <span class="text-nowrap">{{
                                data.valorTotal | currency
                                }}</span>
                            </template>
                            <template slot="percentualContratado" slot-scope="data">
                            <span class="text-nowrap">{{ data.percentualContratado }}%</span>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <span class="text-primary float-left mr-1">
                                    <i
                                        class="fa fa-download fa-lg icon-button"
                                        title="Download"
                                        @click.stop="download(data)"
                                    ></i>
                                </span>
                                <span class="text-danger">
                                    <i
                                        class="fa fa-trash fa-lg icon-button"
                                        title="Deletar"
                                        @click.stop="confirmarDeletar(data)"
                                    ></i>
                                </span>
                            </template>
                        </app-tabela>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import RelatoriosServicos from './RelatoriosServicos'

export default {
    data() {
        return {
            relatorios: [],
            fornecedores: [],
            fornecedor: null,
            nomeFornecedor: "",
            cnpjFornecedor: "",
            campos: [
                {
                    key: 'numeroItem',
                    label: 'Nº do Item',
                    filterable: true,
                    sortable: true,
                    thClass: 'text-left',
                    tdClass: 'text-left'
                },
                {
                    key: 'dataReferencia',
                    label: 'Data de Ref',
                    filterable: true,
                    sortable: true,
                    type: 'date',
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                {
                    key: 'descricaoItem',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'quantidade',
                    label: 'Quant.',
                    sortable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor Unitário',
                    sortable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    sortable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'bdi',
                    label: 'BDI',
                    sortable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'indiceAtualizacoes',
                    label: 'Índice de Att.',
                    sortable: true,
                    tdClass: 'text-left'
                },  
                {
                    key: 'percentualContratado',
                    label: '% Contratado',
                    sortable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },

    components: {
        ModelListSelect
    },

    computed: {
        exibirDadoFornecedor() {
            return this.fornecedor !== null
        },

        exibirSelect() {
            return !(this.$route.params.cnpj)
        }
    },

    mounted() {
        this.obterFiltrosOpcoes(this.$route.params.cnpj)
    },

    methods: {
        onChangeFornecedor() {
            this.obterItemsPorFornecedor(this.fornecedor)
        },

        obterFiltrosOpcoes(cnpj) {
            this.$store.dispatch('addRequest')
            RelatoriosServicos.obterFiltrosOpcoes('ruf').then((response) => {
                if (response) {
                    if (response.success) {
                        this.fornecedores = response.data.Fornecedores
                        if (cnpj)
                            this.obterItemsPorFornecedor(cnpj)
                    } else {
                        this.$toast.error(
                            'Erro ao obter opções do filtro!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },        

        obterItemsPorFornecedor(cnpj) {
             this.$store.dispatch('addRequest')
                RelatoriosServicos.obterRelatoriosIj(cnpj).then((response) => {
                if (response) {
                    if (response.success) {
                        this.relatorios = response.data
                        this.setarDadosFornecedor(cnpj)
                    } else {
                        this.$toast.error(
                            'Erro ao obter relatórios!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        setarDadosFornecedor(cnpj) {
            var fornecedor = this.fornecedores.filter(f => f.cnpj === cnpj)

            if (Array.isArray(fornecedor) && fornecedor.length > 0) {
                fornecedor = fornecedor[0]
                this.fornecedor = fornecedor.cnpj
                this.nomeFornecedor = fornecedor.nome
                this.cnpjFornecedor = this.formatCNPJ(fornecedor.cnpj)
            }
        },

        obterRelatorios() {
            this.$store.dispatch('addRequest')
            RelatoriosServicos.obterRelatoriosIj().then((response) => {
                if (response) {
                    if (response.success) {
                        this.relatorios = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter opções do filtro!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarDeletar(relatorio) {
            this.$swal({
                title: 'Excluir',
                html: `Confirma a exclusão?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluirRelatorio(relatorio.id)
                }
            })
        },
        
        excluirRelatorio(id) {
            this.$store.dispatch('addRequest')
            RelatoriosServicos
                .excluirRelatorioIj(id).then(response => {
                if (response) {
                    if (response.success) {
                        this.obterItemsPorFornecedor(this.fornecedor)
                    } else {
                        this.relatorios = []
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        limparFiltro () {
            this.fornecedor = null
        },

        download(relatorio) {
            RelatoriosServicos.downloadPlanilhaRelatorioIj(relatorio.id).then(response => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao realizar download do arquivo!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, 'RelatorioContratoIJ.xlsx')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },


        isArrayComDados(item)  {
            if (!Array.isArray(item))
                return false;
            else if (item.length === 0)
                return false;
            return true
        },

        formatCNPJ(valor) {
            if (!valor) return '';

            // Extrai os primeiros 14 caracteres alfanuméricos
            const raw = valor.replace(/[^a-zA-Z0-9]/g, '').slice(0, 14);

            // Aplica a máscara: XX.XXX.XXX/XXXX-XX
            let formatted = raw;

            if (raw.length > 2) {
                formatted = raw.slice(0, 2) + '.' + raw.slice(2);
            }
            if (raw.length > 5) {
                formatted = formatted.slice(0, 6) + '.' + formatted.slice(6);
            }
            if (raw.length > 8) {
                formatted = formatted.slice(0, 10) + '/' + formatted.slice(10);
            }
            if (raw.length > 12) {
                formatted = formatted.slice(0, 15) + '-' + formatted.slice(15);
            }
            return formatted;
        }

    },
    watch: {
    }
}
</script>